import React from "react";
import classNames from "classnames";
import { Props, RepartitionByExpenseType } from "./types";
import styles from "./styles.scss";

function chunk<Type>(arr: Type[], size: number): Type[][] {
  return Array.from({ length: Math.ceil(arr.length / size) }, (v, i) =>
    arr.slice(i * size, i * size + size),
  );
}

function isColorLight(color: string) {
  const hex = color.replace("#", "");
  const c_r = parseInt(hex.substring(0, 2), 16);
  const c_g = parseInt(hex.substring(2, 2 + 2), 16);
  const c_b = parseInt(hex.substring(4, 4 + 2), 16);
  const brightness = (c_r * 299 + c_g * 587 + c_b * 114) / 1000;

  return brightness > 155;
}

function ExpensesBreakdownByExpenses({ projectExpenses }: Props) {
  const repartition = projectExpenses
    .filter(({ quantity }) => quantity > 0)
    .reduce<RepartitionByExpenseType>(
      (acc, { expenseType: { uuid, color, name }, unitAmount, quantity }) => ({
        ...acc,
        [uuid]: {
          color,
          name,
          value: (acc[uuid]?.value ?? 0) + Number(unitAmount) * quantity,
        },
      }),
      {},
    );
  const maxValue = projectExpenses.reduce(
    (acc, { unitAmount, quantity }) => acc + Number(unitAmount) * quantity,
    0,
  );

  return (
    <div className={styles.expensesBreakdownByExpenses}>
      <div className={styles.budgetBar}>
        {Object.keys(repartition).map((key) => {
          const percent = Math.round((repartition[key].value * 100) / maxValue);

          return (
            <div
              key={key}
              className={classNames({
                [styles.light]: isColorLight(repartition[key].color),
              })}
              style={{
                width: `${percent}%`,
                backgroundColor: repartition[key].color,
              }}
            >
              {percent}%
            </div>
          );
        })}
      </div>
      <div className={styles.legend}>
        {chunk(Object.keys(repartition), 2).map((keys, index) => (
          <div key={index} className={styles.col}>
            {keys.map((key) => (
              <div key={key} className={styles.legendItem}>
                <div
                  className={styles.legendColor}
                  style={{
                    backgroundColor: repartition[key].color,
                  }}
                />
                <p>
                  {repartition[key].name} (
                  {repartition[key].value.toLocaleString()}€)
                </p>
              </div>
            ))}
            {keys.length < 2 && <div className={styles.legendItem} />}
          </div>
        ))}
      </div>
    </div>
  );
}

export { ExpensesBreakdownByExpenses };
